import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function ExchangeCommissionsIcon() {
  /* eslint react/no-danger: 0 */
  const tooltip = (
    <Tooltip className="in">
      <span dangerouslySetInnerHTML={{ __html: "Exchange Manager" }} />
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <span className="fa-stack fa-1x" style={{ marginLeft: "10px" }}>
        <i className="fa fa-lg fa-circle text-success" />
        <span
          className="fa fa-stack-1x exchange-circle-text"
          style={{ left: "-5px" }}
        >
          E
        </span>
      </span>
    </OverlayTrigger>
  );
}



// WEBPACK FOOTER //
// ./app/modules/users/components/shared/ExchangeCommissionIcon.jsx